// extracted by mini-css-extract-plugin
export default {"productionFact":"ProductionFact_productionFact__iduWB","label":"ProductionFact_label__m8A1t","value":"ProductionFact_value__FYLh9"};